import { graphql } from "@/gql";

export const createQRCodeMutation = graphql(`
  mutation GenerateQRCode($text: String!) {
    generateQRCode(text: $text)
  }
`);
